import type { FaireProductEntity } from "../../entity_types/product";

export const p_mfd5uyafku: FaireProductEntity = {
  token: "p_mfd5uyafku",
  type: "product",
  name: '(KG)CATHEDRAL - AMETHYST B 13-24"',
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/d37924fa763e9220f9bd31e31a82fbfa88390eca25797081bb103c679384f032.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.09,
  description:
    'Oceanic Linkways Inc presents our Cathedral - Amethyst B 13-24". This spiritual stone/crystal is not just an ornament, but a unique piece meticulously chosen from 19 countries to ensure high quality. Ideal for enhancing the ambiance of your home or workspace, or as a thoughtful gift. Visit www.oceaniclink.com for more of our offerings.',
  tags: [],
  msrpDollars: 52.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:00.869Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
